import { render, staticRenderFns } from "./MojArhiv.vue?vue&type=template&id=102c0ce9&scoped=true&"
import script from "./MojArhiv.vue?vue&type=script&lang=js&"
export * from "./MojArhiv.vue?vue&type=script&lang=js&"
import style0 from "./MojArhiv.vue?vue&type=style&index=0&id=102c0ce9&lang=scss&scoped=true&"
import style1 from "./MojArhiv.vue?vue&type=style&index=1&id=102c0ce9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102c0ce9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VSimpleTable})
